import { ESTADO_FISCAL, ESTADO_IMPRESION, RANURA } from "./index";

// Textos de la pantalla. "Enviada" y no "impresa": el navegador no confirma
// que el papel haya salido, así que la reimpresión queda siempre disponible.
const DESCRIPCIONES = {
  [ESTADO_IMPRESION.SIN_SOLICITAR]: {
    titulo: "Sin solicitar",
    detalle: "Todavía no se envió a la impresora.",
    tono: "neutro",
  },
  [ESTADO_IMPRESION.PREPARANDO]: {
    titulo: "Preparando…",
    detalle: "Armando el documento y enviándolo al navegador.",
    tono: "neutro",
  },
  [ESTADO_IMPRESION.SOLICITADA]: {
    titulo: "Enviada a la impresora",
    detalle: "Si el papel no salió, reimprimí.",
    tono: "ok",
  },
  [ESTADO_IMPRESION.ERROR_LOCAL]: {
    titulo: "No se pudo solicitar",
    detalle: "Falló la impresión en este equipo. La venta quedó registrada.",
    tono: "error",
  },
  [ESTADO_IMPRESION.NO_APLICA]: {
    titulo: "No aplica",
    detalle: "No hay documento para imprimir.",
    tono: "neutro",
  },
  [ESTADO_IMPRESION.PENDIENTE_AFIP]: {
    titulo: "Pendiente de AFIP",
    detalle: "La factura no existe todavía; se podrá imprimir cuando AFIP responda.",
    tono: "alerta",
  },
};

export const describirEstadoImpresion = (estado) =>
  DESCRIPCIONES[estado] || DESCRIPCIONES[ESTADO_IMPRESION.NO_APLICA];

// Leyenda discreta de la comanda remota en el cierre de la venta. Acá el 200
// del print server sí confirma que el trabajo llegó a cafetería. Null cuando
// no aplica (100 % menú universitario o demo): no se muestra nada.
const LEYENDAS_COMANDA_REMOTA = {
  [ESTADO_IMPRESION.SIN_SOLICITAR]: "Enviando comanda a cafetería…",
  [ESTADO_IMPRESION.PREPARANDO]: "Enviando comanda a cafetería…",
  [ESTADO_IMPRESION.SOLICITADA]: "Comanda enviada a cafetería",
  [ESTADO_IMPRESION.ERROR_LOCAL]: "No se pudo enviar la comanda a cafetería",
};

export const leyendaComandaRemota = (estado) => LEYENDAS_COMANDA_REMOTA[estado] || null;

// Nombre del primer papel según lo que realmente se va a imprimir.
export const tituloRanura = (ranura, documentos) => {
  if (ranura === RANURA.COMANDA) return "Comanda";
  switch (documentos?.estadoFiscal) {
    case ESTADO_FISCAL.FACTURADA:
      return documentos.factura?.tipo ? `Factura ${documentos.factura.tipo}` : "Factura";
    case ESTADO_FISCAL.NO_APLICA_TOTAL_CERO:
      return "Constancia bonificada";
    default:
      return "Factura";
  }
};

export const puedeSolicitar = (estado) =>
  [
    ESTADO_IMPRESION.SIN_SOLICITAR,
    ESTADO_IMPRESION.SOLICITADA,
    ESTADO_IMPRESION.ERROR_LOCAL,
  ].includes(estado);
